module.exports = __webpack_public_path__ + "img/answer-language-en.3b9be558.png";